import { Stack, Typography } from "@mui/material";
import { useContext, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import UserContext from "../../../services/Context/UserContext";
import useTargetUrl from "../utils/useTargetUrl";
import useProduct from "../utils/useProduct";
import OriginSelect from "./OriginSelect";
import useCourse from "../utils/useCourse";
import useCategory from "../utils/useCategory";
import useCart from "../utils/useCart";
import { txt } from "../../../services/translation";

export default function Confirm(){

    const navigate = useNavigate();

    const { user } = useContext(UserContext)

    const { id } = useParams()

    const { cart } = useCart();

    const product = useProduct()

    const course = useCourse()

    const targetUrl = useTargetUrl()

    const category = useCategory()

    const link = useMemo(() => {

        return user ? targetUrl : `/courses/${id}/auth`;

    }, [user, id, targetUrl])

    const handleSubmit = e => {
        e.preventDefault();
        navigate(link);
    }

    if (!cart.productsLoaded) return <></>;

    if (!product && !course?.free) return <></>

    return (

        <form onSubmit={handleSubmit}>
    
            <Stack spacing={3} alignItems="center">

                <OriginSelect />

                <button
                    className="apply-confirm-button"
                    type="submit"
                    style={{ backgroundColor: category?.color || 'royalblue' }}
                >
                    <Typography>{txt('CONFIRM')}</Typography>
                </button>

            </Stack>

        </form>
    );
}